module.exports = __webpack_public_path__ + "img/3.10a196b3.jpg";